module.exports = __webpack_public_path__ + "img/icon_compensatory_service.e650bde4.svg";